import CopyButton from "@components/buttons/CopyButton";
import DataPill from "@components/pills/DataPill";
import { DIDIT_KYC_MODULES, DiditKycDetails } from "@services/models/Kyc/KycV2Models";

interface DiditKycModulesProps {
  kycDetails?: DiditKycDetails | null;
}

const DiditKycModules = ({ kycDetails }: DiditKycModulesProps) => {
  const modules = kycDetails?.modules;

  return (
    <div className="flex flex-col gap-2">
      <p className="text-text-base text-[11px] font-semibold">
        Verification modules
      </p>
      {DIDIT_KYC_MODULES.map(({ key, label }) => {
        const moduleState = modules?.[key];
        const status = moduleState?.status;
        const sessionId = moduleState?.sessionId?.trim() || "";

        return (
          <div
            key={key}
            className="flex flex-col gap-2 rounded-md border border-border-subtle px-2 py-2"
          >
            <div className="flex items-center justify-between gap-2">
              <span className="text-text-base text-[12px] font-medium">
                {label}
              </span>
              <DataPill value={status} />
            </div>
            <div className="flex items-center justify-between gap-2">
              <span className="text-[10px] text-text-subtle">
                {moduleState?.isRequired ? "Required" : "Optional"}
              </span>
            </div>
            {sessionId && (
              <div className="flex items-center justify-between gap-2">
                <span className="text-[10px] text-text-subtle">
                  Session ID
                </span>
                <div className="flex items-center gap-1 min-w-0">
                  <span className="text-text-base text-[11px] font-normal truncate">
                    {sessionId}
                  </span>
                  <CopyButton
                    copyText={sessionId}
                    copyMessage="Session ID copied"
                    copyIconSize={10}
                    buttonSize="14px"
                    borderRadius="2px"
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DiditKycModules;
